import { useThemedMarkdownStyle } from "#use-themed-markdown-style";
import { useMemo } from "react";
import { StyleSheet, View } from "@-/com.npmjs.react-native";
import {
  EnrichedMarkdownText,
  EnrichedMarkdownTextInput,
} from "@-/com.npmjs.react-native-enriched-markdown";

const BRACKET_LINK_SCHEME = "han-bracket://highlight";

const styles = StyleSheet.create({
  input: { minHeight: 80, padding: 8 },
});

function preprocessBracketHighlights(content: string): string {
  return content.replaceAll(
    /(!?)\[([^\]\n]+)\](\()?/g,
    (match, bang: string, text: string, open) => {
      if (bang === "!" || open === "(") {
        return match;
      }
      return `[${text}](${BRACKET_LINK_SCHEME})`;
    },
  );
}

export function MorphemeDescriptionRenderer({
  className,
  content,
  isEditing = false,
  onChange,
  onLinkPress,
  placeholder,
  size = "base",
}: {
  className?: string;
  content: string;
  isEditing?: boolean;
  onChange?: (value: string) => void;
  onLinkPress?: (event: { url: string }) => void;
  placeholder?: string;
  size?: "base" | "sm";
}) {
  const preprocessed = useMemo(() => preprocessBracketHighlights(content), [content]);
  const markdownStyle = useThemedMarkdownStyle(size);

  if (isEditing) {
    return (
      <View className={className}>
        <EnrichedMarkdownTextInput
          defaultValue={content}
          markdownStyle={markdownStyle}
          onChangeMarkdown={onChange}
          placeholder={placeholder}
          style={styles.input}
        />
      </View>
    );
  }

  return (
    <View className={className}>
      <EnrichedMarkdownText
        markdown={preprocessed}
        markdownStyle={markdownStyle}
        onLinkPress={onLinkPress}
      />
    </View>
  );
}
